import React from 'react';
import PropTypes from 'prop-types';

import ExpandableSection from '../../components/ExpandableSectionDocuments';
import LocationsIconSolid from '../../components/Iconoclast/LocationsIconSolid';
import MobileUserCard from './MobileUserCard';
import dataModel from '../../models/DataModel';
import DocumentsList from '../../components/TaskCRUD/DocumentsList';
import FileUtil from '../../helpers/FileUtil/FileUtil';
import AttachmentHelper from '../../helpers/AttachmentHelper';
import VideoPlayer from '../../components/VideoPlayer';

import './ProjectDetailsContainer.scss';

const project_descriptor = {
  project: {
    project_manager: {},
    delays: {
      attachments: { additionalFields: ['upload', 'photo_longitude', 'photo_latitude', 'photo_taken_at'] },
    },
    location: { location_users: { user: {} } },
    project_contacts: { user: {} },
    company: {},
    unique_documents: {},
    reference_documents: {},
    custom_project_settings: {},
  },
};

export class ProjectDetailsContainer extends React.Component {

  constructor(props) {
    super(props);

    ProjectDetailsContainer.propTypes = {
      project: PropTypes.object.isRequired,
    };
    this.state = {
      project: null,
    };
    this.openAddress = this.openAddress.bind(this);
    this.openCoordinates = this.openCoordinates.bind(this);
    this.handleOpenDoc = this.handleOpenDoc.bind(this);
    this.handleUserCardClick = this.handleUserCardClick.bind(this);
    this.validImageTypes = ['jpg','jpeg','png','svg'];
    this.validVideoTypes = ['mp4','m4v','wmv','mpeg','flv','mov','qt','mp4v'];
  }

  componentDidMount() {
    const { project } = this.props;
    if (project) {
      dataModel.projectsDAO.getProject(project.id, { recordDescriptor: project_descriptor }).then(fetchedProject => {
        this.setState({ project: fetchedProject });
      });
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.project != this.props.project) {
      dataModel.projectsDAO.getProject(this.props.project.id, { recordDescriptor: project_descriptor }).then(fetchedProject => {
        this.setState({ project: fetchedProject });
      });
    }
  }

  // Navigate to native user details
  handleUserCardClick(user) {
    if (user && user.id) {
      this.props.history.push('/mobile/users/' + user.id);
    }
  }

  handleOpenDoc(referenceDocument){
    if (referenceDocument) {
      if (referenceDocument.group_identifier) {
        dataModel.referenceDocumentsDAO.getReferenceDocument(referenceDocument.id,
          { force: true, recordDescriptor: { reference_document: { conversions: { } } } }).then((refDoc) => {
            this.setState({ displayRefDoc: refDoc });
            this.props.handleRefDocOpen();
          });
      }
      else {
        dataModel.uniqueDocumentsDAO.getUniqueDocument(referenceDocument.id,
          { force: true, recordDescriptor: { unique_document: { conversions: { } } } }).then((refDoc) => {
            this.setState({ displayRefDoc: refDoc });
            this.props.handleRefDocOpen();
          });
      }
    }
  }

  openCoordinates() {
    const location = this.props.project.location;
    const isIos = navigator.userAgent ? /(iphone)/i.test(navigator.userAgent.toLowerCase()) : false;
    const mapsQuery = location.latitude + ',' + location.longitude;

    if (isIos) {
      window.open('maps://?q='+mapsQuery, '_system');
    }
    else {
      window.open('geo:0,0?q='+mapsQuery);
    }
  }

  openAddress() {
    const location = this.props.project.location;
    const mapsQuery = location.address + ' ' + location.city + ', ' + location.state + ' ' + location.zip;
    const isIos = navigator.userAgent ? /(iphone)/i.test(navigator.userAgent.toLowerCase()) : false;

    if (isIos) {
      window.open('maps://?q='+mapsQuery, '_system');
    }
    else {
      window.open('geo:0,0?q='+mapsQuery);
    }
  }

  createLocationDetails() {
    const location = this.state.project.location;
    let address, coordinates;

    if (location && location.address) {
      address = (
        <div className="address" onClick={!this.props.fromPopup ? this.openAddress : null}>
          <h1>Address:</h1>
          <p className={this.props.fromPopup && 'from-popup'}>
            {`${location.address}`}
            <br />
            {`${location.city}, ${location.state} ${location.zip}`}
          </p>
        </div>
      );
    }

    if (location && location.latitude && location.longitude) {
      coordinates = (
        <div className="coordinates" onClick={!this.props.fromPopup ? this.openCoordinates : null}>
          <h1>Coordinates:</h1>
          <p className={this.props.fromPopup && 'from-popup'}>{`${location.latitude}, ${location.longitude}`}</p>
        </div>
      );
    }
    return (
      <div className="project-details__location-address" >
        <LocationsIconSolid 
          fillColor="#184E78" 
          style={{ transform: 'scale(.7, .7' }}
        />
        <div className="location-info-container">
          { coordinates }
          { address }
        </div>
      </div>
    );
  }

  handleCheckIsImage(attachment) {
    let ext = FileUtil.getExtension(attachment.name);
    return this.validImageTypes.includes(ext.toLowerCase());
  }

  handleCheckIsVideo(attachment) {
    if (attachment.attachment_content_type) {
      return attachment.attachment_content_type.toLowerCase().startsWith('video');
    }
    let ext = FileUtil.getExtension(attachment.name);
    return this.validVideoTypes.includes(ext.toLowerCase());
  }

  render() {
    const { project } = this.state;
    if (!project) {
      return null;
    }
    const { fromPopup } = this.props;
    const location = project.location;
    const projectLocationContacts = location ? location.location_users : [];
    const projectContacts = project.project_contacts ? project.project_contacts : [];
    let projectManagerCard, locationContactCards;
    const isOnline = !dataModel.isOffline;

    // User Cards
    if (project.project_manager) {
      projectManagerCard = <MobileUserCard fromPopup={fromPopup} online={isOnline} title="PM" user={project.project_manager} handleCardClick={this.handleUserCardClick}/>;
    }
    if (projectLocationContacts && projectLocationContacts.length) {
      locationContactCards = projectLocationContacts.map(
        locationUser => {
          return <MobileUserCard fromPopup={fromPopup} online={isOnline} key={'user-card-' + locationUser.id} title={locationUser.title} user={locationUser.user} handleCardClick={this.handleUserCardClick} />;
        }
      );
    }

    let projectContactCards = null;
    if (projectContacts && projectContacts.length) {
      projectContactCards = projectContacts.map(
        projectContact => {
          return <MobileUserCard fromPopup={fromPopup} online={isOnline} key={'user-card-' + projectContact.id} title={projectContact.title}
            user={projectContact.user} handleCardClick={this.handleUserCardClick} />;
        }
      );
    }

    // Project Status

    let refDoc = null;
    let style = {};
    if(this.props.refDocOpen){
      let referenceDocument = this.state.displayRefDoc;
      let content;
      let isImage = this.handleCheckIsImage(referenceDocument);
      if (!isImage) {
        if (this.handleCheckIsVideo(referenceDocument)) {
          const attachment = referenceDocument.attachment;
          const type = attachment && attachment.upload_content_type ? attachment.upload_content_type : (attachment && attachment.upload && attachment.upload.type) ? attachment.upload.type : undefined;
          content = <VideoPlayer src={referenceDocument.attachment} width={window.innerWidth - 20} height={328} type={type}/>;
        } else {
          content = AttachmentHelper.getConvertedDocumentView(referenceDocument);
        }
      }
      else {
        content = <img className="display-ref-doc" src={referenceDocument.attachment} alt={'Reference Doc'}/>;
      }
      refDoc = (
        <div className='ref-doc'>
          {content}
        </div>
      );
      style = { display: 'none' };
    }
    return (
      <div className={'project-details' + (fromPopup ? ' from-popup' : '')}>
        {refDoc}

        <div style={style}>
        { 
          location && this.createLocationDetails()
        } 
        {projectManagerCard}
          {locationContactCards}
          {projectContactCards}
        <div>
          {
            location && location.notes &&
            <ExpandableSection name="Location Notes">
              <p className="project-details__notes">{location.notes}</p>
            </ExpandableSection>
          } 
          { 
            project.custom_project_settings && project.custom_project_settings.notes &&
            <ExpandableSection name="Project Notes">
              <p className="project-details__notes">{project.custom_project_settings.notes}</p>
            </ExpandableSection>
          }
          <ExpandableSection name='DOCUMENTS' id="docs-section" initiallyExpanded={!fromPopup} >
            {project.reference_documents &&
              <DocumentsList
                documents={project.reference_documents}
                handleOpenDoc={this.handleOpenDoc}
                documentType='reference'
                parentComponentView={'project'}
              />}
              <DocumentsList
                documentType='project'
                documents={project.unique_documents}
                canDeleteDocuments={false}
                handleOpenDoc={this.handleOpenDoc} 
                parentComponentView={'project'}
                />
              </ExpandableSection>
        </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/ProjectDetailsContainer/index.js